"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeConnection = void 0;
const channel_1 = require("./channel");
const transports_1 = require("./transports");
exports.RealtimeConnection = (config) => {
    const transport = transports_1.getTransport(config);
    const getChannel = (target) => {
        const channel = channel_1.RealtimeChannel(transport, target);
        return channel;
    };
    const disconnect = () => {
        transport.disconnect();
    };
    return {
        getChannel,
        disconnect,
    };
};
